import { S3_BUCKET_URL } from '@/constants';
import { PAYWALL_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';
import { useManLayoutSelections } from '@/pages/Onboarding/hooks/useManLayoutSelections';

export const useManBackgroundImage = () => {
  const {
    ageGeneration: manAgeGeneration,
    bodyShape: manBodyShape,
    ethnicity,
  } = useManLayoutSelections();

  if (webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.REAL_MAN_PHOTOS)) {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/real-man-photos/${ethnicity}_${manAgeGeneration}_${manBodyShape}.png`;
  }

  if (webCampaign.setup.paywallNotes.includes(PAYWALL_NOTES.PROD_2506)) {
    return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/PROD-2506/${manAgeGeneration}/${ethnicity}_${manBodyShape}.png`;
  }

  return `${S3_BUCKET_URL}/paywall/fast-pay-tab-man/${manAgeGeneration}/${ethnicity}_${manBodyShape}.png`;
};
